module.exports = __webpack_public_path__ + "media/fonts/fontawesome-webfont-a492f3a9481d9ce640832670994e5e64.woff";